import { createContext, useContext } from "react";

export interface UserEntity {
  uid: string;
  mail: string;
  name: string;
  role: string;
  icon: string;
  admin: boolean;
  impersonated: boolean;
}

export const UserProvider = createContext<UserEntity | undefined>(undefined);

export function useCurrentUser() {
  return useContext(UserProvider);
}
